export const sseMessageSelector = (state: any) => state?.sse?.latestMessage;

export const sseFileToDownloadSelector = (state: any) => state?.sse?.sseFileToDownload;
